import { render } from "./ian-feedback.vue?vue&type=template&id=9ae55a92&scoped=true"
import script from "./ian-feedback.vue?vue&type=script&lang=js"
export * from "./ian-feedback.vue?vue&type=script&lang=js"

import "./ian-feedback.vue?vue&type=style&index=0&id=9ae55a92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ae55a92"]])

export default __exports__